import { Col, Container, Dropdown, Image, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from 'assets/img/landing/applicationLogo.svg';
import Button from 'components/base/Button';
import ThemeToggler from 'components/common/ThemeToggler';
import MobileNav from './MobileNav/MobileNav';
import { NavOptions, Props } from './header.type';
import { LandingRole } from 'pages/landing/main.type';
import { ReactNode } from 'react';

const roleLogin = ['student', 'default', 'recruiter', 'college'];
const navMappping: Record<LandingRole, NavOptions> = {
  student: [],
  default: [
    {
      label: 'Solutions',
      isDropdown: true,
      path: '',
      childNavs: [
        { label: 'Student', path: '/welcome/student' },
        { label: 'Institution', path: '/welcome/institution' },
        { label: 'Recruiter', path: '/welcome/recruiter' }
      ]
    },
    { label: 'About Us', isDropdown: false, path: '/about' },
    { label: 'Contact Us', isDropdown: false, path: '/contact' }
  ],
  college: [],
  recruiter: []
};

function Header({ role }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  const navs = navMappping[role];
  const currentPath = location.pathname;

  const signUpButtonMapping: Record<LandingRole, ReactNode | null> = {
    default: null,
    student: null,
    recruiter: (
      <Button
        variant="subtle-secondary"
        className="ms-4 px-5 d-none d-lg-block"
        as={Link}
        to="/register/recruiter/basic"
      >
        Sign Up
      </Button>
    ),
    college: (
      <Button
        variant="subtle-secondary"
        className="ms-4 px-5 d-none d-lg-block"
        as={Link}
        to="/register/institution/basic"
      >
        Sign Up
      </Button>
    )
  };

  const isShowLogin = roleLogin.includes(role);

  const handleNavClick = (path: string) => {
    if (path) {
      navigate(path);
    }
  };

  const goDefault = () => {
    navigate('/');
  };

  return (
    <Container fluid className="px-lg-10 py-4 bg-body-highlight">
      <Row>
        <Col lg={1} md={1} sm={1} xs={2}>
          <Image
            src={Logo}
            alt="application-logo"
            width={50}
            height={50}
            onClick={goDefault}
            className="cursor-pointer"
          />
        </Col>
        <Col
          lg={11}
          md={11}
          sm={11}
          xs={10}
          className="d-flex align-items-center justify-content-end md-visually-hidden"
        >
          <div className="d-lg-flex align-items-center flex-wrap d-none">
            {navs.map((details, index) => {
              return details.isDropdown ? (
                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle
                    id="dropdown-autoclose-true"
                    className="bg-transparent text-body-highlight fs-8 fw-normal px-0 ms-4 customToggleStyle"
                  >
                    {details.label}
                  </Dropdown.Toggle>
                  {Array.isArray(details.childNavs) && (
                    <Dropdown.Menu>
                      {details.childNavs.map((list, index) => (
                        <Dropdown.Item
                          as={Link}
                          to={list.path}
                          key={`${index}-childNav`}
                        >
                          {list.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  )}
                </Dropdown>
              ) : (
                <p
                  key={`nav-${index}`}
                  className={`m-0 ms-4 cursor-pointer fs-8 ${
                    currentPath === details.path
                      ? 'text-primary'
                      : 'text-body-highlight'
                  }`}
                  onClick={() => handleNavClick(details.path)}
                >
                  {details.label}
                </p>
              );
            })}
          </div>
          <ThemeToggler className="ms-8" tooltipPlacement="bottom" />
          {isShowLogin && (
            <Button
              as={Link}
              to="/sign-in"
              variant="primary"
              className={`px-6 ms-4 d-lg-block ${navs.length > 0 && 'd-none'}`}
            >
              Log In
            </Button>
          )}
          {signUpButtonMapping[role]}
          {Array.isArray(navs) && navs.length > 0 && (
            <MobileNav navsList={navs} />
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Header;
